module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_DUEFTE.5d57854d.png";